import { ref } from 'vue';

export function useLoadingState() {
    const isLoading = ref(false);
    const icon = ref(null);

    const withLoading = async (fn, customIcon = 'pi-spinner') => {
        try {
            isLoading.value = true;
            icon.value = `pi-spin ${customIcon}`;
            await fn();
        } catch (err) {
            console.error(err);
        } finally {
            isLoading.value = false;
            icon.value = null;
        }
    };

    return {
        isLoading,
        icon,
        withLoading,
    };
}
